import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RiskLevelIconComponent } from '../risk-level-icon/risk-level-icon.component';

@Component({
  selector: 'nk-bankruptcy-risk-score-level-item',
  templateUrl: './bankruptcy-risk-score-level-item.component.html',
  imports: [TranslateModule, RiskLevelIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BankruptcyRiskScoreLevelItemComponent {
  public groupKey = input.required<string>();
}
